<template>
	<div>
		<canvas ref="canvas"></canvas>
		<LoadingSpinner v-if="!datasets || !datasets.length" />
	</div>
</template>

<script>
import {
	Chart,
	ArcElement,
	LineElement,
	BarElement,
	PointElement,
	BarController,
	BubbleController,
	DoughnutController,
	LineController,
	PieController,
	PolarAreaController,
	RadarController,
	ScatterController,
	CategoryScale,
	LinearScale,
	LogarithmicScale,
	RadialLinearScale,
	TimeScale,
	TimeSeriesScale,
	Decimation,
	Filler,
	Legend,
	Title,
	Tooltip,
} from 'chart.js';
import LoadingSpinner from '@/components/navigation/LoadingSpinner';

Chart.register(
	ArcElement,
	LineElement,
	BarElement,
	PointElement,
	BarController,
	BubbleController,
	DoughnutController,
	LineController,
	PieController,
	PolarAreaController,
	RadarController,
	ScatterController,
	CategoryScale,
	LinearScale,
	LogarithmicScale,
	RadialLinearScale,
	TimeScale,
	TimeSeriesScale,
	Decimation,
	Filler,
	Legend,
	Title,
	Tooltip,
);

export default {
	name: 'BaseChart',
	components: { LoadingSpinner },
	props: {
		labels: {
			required: true,
		},
		datasets: {},
		type: { type: String, default: 'chart' },
	},
	computed: {
		colors() {
			return [
				'255, 99, 132',
				'54, 162, 235',
				'255, 206, 86',
				'75, 192, 192',
				'24, 139, 204',
				'153, 102, 255',
				'255, 159, 64',
				'112, 255, 206',
				'179, 140, 43',
			];
		},
		getDatasets() {
			let i = 0;

			return this.datasets?.map(dataset => {
				dataset.backgroundColor = [];
				dataset.borderColor = [];
				dataset.hoverBackgroundColor = [];

				dataset.data.forEach(data => {
					dataset.backgroundColor.push('rgba(' + this.colors[i] + ', 0.4)');
					dataset.borderColor.push('rgba(' + this.colors[i] + ', 1)');
					dataset.hoverBackgroundColor.push('rgba(' + this.colors[i] + ', 0.6)');
				});

				i++;
				if (i >= this.colors.length) {
					i = 0;
				}

				dataset.borderWidth = dataset.borderWidth || 1;

				return dataset;
			});
		},
	},
	data() {
		return {
			chart: null,
		};
	},
	methods: {
		render() {
			if (this.chart) {
				this.chart.options.animation = false;
				this.chart.destroy();
			}

			if (this.type.toString() === 'pie') {
				this.chart = new Chart(this.$refs.canvas, {
					type: 'pie',
					data: { labels: this.labels, datasets: this.datasets },
					options: {
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							legend: {
								position: 'top',
							},
							title: {
								display: false,
								text: 'Chart.js Pie Chart',
							},
						},
					},
				});
			} else {
				this.chart = new Chart(this.$refs.canvas, {
					type: 'bar',
					data: {
						labels: this.labels,
						datasets: this.getDatasets,
					},
					options: {
						plugins: {
							tooltip: {
								callbacks: {
									label(tooltipItem) {
										return tooltipItem.dataset.label + ': ' + tooltipItem.formattedValue;
									},
								},
							},
						},
						responsive: true,
						maintainAspectRatio: false,
						scales: {
							y: {
								beginAtZero: true,
							},
						},
					},
				});
			}
		},
	},
	watch: {
		labels() {
			if (this.chart) {
				this.chart.options.labels = this.labels;
				this.render();
			}
		},
		datasets: {
			immediate: true,
			deep: true,
			handler() {
				if (this.datasets && this.datasets.length) {
					this.render();
				}
			},
		},
	},
};
</script>

<style scoped></style>
